
import React from 'react';
import ReactDOM from 'react-dom';
import CategoriesMenu from '/home/circleci/app/components/CategoriesMenu';

const element = typeof document !== 'undefined' && document.querySelector('#CategoriesMenu');

if (element) {
    const props = window.initialData['CategoriesMenu'];

    ReactDOM.render(
        <CategoriesMenu {...props}/>,
        element
    );
}

export default CategoriesMenu;
